import {IAbstractCommentConfiguration} from "@webng-types/write-model";
import {isNativeCommentConfiguration, isViafouraCommentConfiguration} from "@webng/liveblog-edit-utils";

export function commentsEnabled(comments: IAbstractCommentConfiguration | undefined): boolean {
  if (isNativeCommentConfiguration(comments)) {
    return !!(comments.enabled && typeof comments.publish_mode === 'number' && comments.publish_mode < 100);
  }

  if (isViafouraCommentConfiguration(comments)) {
    return !!comments.enabled;
  }

  return false;
}
